import { useTranslation } from 'react-i18next'

const ESTADO = {
  borrador: 'bg-gray-100 text-gray-600',
  solicitada: 'bg-amber-100 text-amber-800',
  propuesta: 'bg-amber-100 text-amber-800',
  devuelta: 'bg-rose-100 text-rose-700',
  planificada: 'bg-sky-100 text-sky-800',
  liberada: 'bg-indigo-100 text-indigo-700',
  en_ejecucion: 'bg-emerald-100 text-emerald-800',
  terminada: 'bg-teal-100 text-teal-800',
  cerrada: 'bg-gray-200 text-gray-700',
  cancelada: 'bg-gray-200 text-gray-500',
}

// An OT's state as a pill.
export function EstadoOt({ estado }) {
  const { t } = useTranslation('operations')
  return (
    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${ESTADO[estado] || 'bg-gray-100 text-gray-600'}`}>
      {t(`ot.estados.${estado}`, { defaultValue: estado })}
    </span>
  )
}

// A flag inside the state (espera_componentes, espera_material, pausada).
export function SubestadoOt({ subestado }) {
  const { t } = useTranslation('operations')
  if (!subestado) return null
  return (
    <span className="inline-flex px-1.5 py-0.5 rounded text-[11px] font-medium bg-yellow-100 text-yellow-800 whitespace-nowrap">
      ⏳ {t(`ot.subestados.${subestado}`, { defaultValue: subestado })}
    </span>
  )
}

const LUZ = { verde: 'bg-emerald-500', amarillo: 'bg-amber-400', rojo: 'bg-rose-500' }

// The traffic light: can the OT move on (verde), is it waiting for
// something (amarillo), or was it sent back / blocked (rojo)? The reason
// shows on hover, or next to it with conTexto.
export function Semaforo({ semaforo, conTexto = false }) {
  const { t } = useTranslation('operations')
  if (!semaforo) return null
  const texto = t(`ot.semaforo.${semaforo.motivo}`, { defaultValue: semaforo.motivo })
  return (
    <span className="inline-flex items-center gap-1.5" title={texto}>
      <span className={`inline-block w-2.5 h-2.5 rounded-full ring-2 ring-white ${LUZ[semaforo.color] || 'bg-gray-300'}`} aria-hidden />
      {conTexto ? <span className="text-xs text-gray-600">{texto}</span> : <span className="sr-only">{texto}</span>}
    </span>
  )
}

// The origin of the demand, only when it isn't the usual (a project).
export function OrigenOt({ origen }) {
  const { t } = useTranslation('operations')
  if (!origen || origen === 'proyecto') return null
  return (
    <span className={`inline-flex px-1.5 py-0.5 rounded text-[11px] font-medium whitespace-nowrap ${
      origen === 'mantenimiento' ? 'bg-teal-100 text-teal-800' : 'bg-orange-100 text-orange-800'}`}>
      {t(`ot.origenes.${origen}`, { defaultValue: origen })}
    </span>
  )
}
